<div class="emperor-ui-chip" [ngClass]="colorClass">
  <ng-content></ng-content>
</div>
